module.exports = __webpack_public_path__ + "img/mts-green.8db8bf0f.svg";